const { dateUtil, helpers } = require("../../utils");

export const savingsColumns = [
  // {
  //   title: "Name",
  //   dataIndex: "userId",
  //   key: "userId",
  //   render: (userId) => (
  //     <p>
  //       {userId.first_name} {userId.last_name}
  //     </p>
  //   ),
  // },
  {
    title: "Plan Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Plan Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Contribution",
    dataIndex: "contribution",
    key: "contribution",
  },
  {
    title: "Frequency",
    dataIndex: "frequency",
    key: "frequency",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Balance",
    dataIndex: "balance",
    key: "balance",
  },
  {
    title: "Total Withdrawan",
    dataIndex: "totalAmountWithdrawn",
    key: "totalAmountWithdrawn",
  },
  {
    title: "Full Withdrawal",
    dataIndex: "fullWithdrawalMade",
    key: "fullWithdrawalMade",
    render: (value) => <p>{value ? "Yes" : "No"}</p>,
  },

  {
    title: "Total Withdrawn",
    dataIndex: "balance",
    key: "totalAmountWithdrawn",
  },
  {
    title: "Started",
    dataIndex: "startDate",
    key: "startDate",
    render: (startDate) => <p>{dateUtil.formatFullDateTime(startDate)}</p>,
  },
  {
    title: "Ends",
    dataIndex: "expectedEndDate",
    key: "expectedEndDate",
    render: (expectedEndDate) => (
      <p>{dateUtil.formatFullDateTime(expectedEndDate)}</p>
    ),
  },
  {
    title: "Actions",
    key: "action",
  },
];
//
export const investmentColumns = [
  {
    title: "Name",
    dataIndex: "userId",
    key: "userId",
    render: (userId) => (
      <p>
        {userId.first_name} {userId.last_name}
      </p>
    ),
  },
  {
    title: "Plan Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Plan Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Returns Type",
    dataIndex: "investmentReturnsType",
    key: "investmentReturnsType",
  },
  {
    title: "active",
    dataIndex: "active",
    key: "active",
    render: (value) => <p>{value ? "Yes" : "No"}</p>,
  },
  {
    title: "Balance",
    dataIndex: "",
    key: "x",
    render: (investment) => {
      const { balance, currency } = investment;
      return <p>{helpers.toCurrency(balance, currency)}</p>;
    },
  },

  {
    title: "Principal Withdrawn",
    dataIndex: "principalWithdrawn",
    key: "principalWithdrawn",
    render: (value) => <p>{value ? "Yes" : "No"}</p>,
  },
  {
    title: "Referral Interest",
    dataIndex: "referralInterestWithdrawn",
    key: "referralInterestWithdrawn",
    render: (value) => <p>{value ? "Withdrawn" : "Not Withdrawn"}</p>,
  },

  {
    title: "Started",
    dataIndex: "startDate",
    key: "startDate",
    render: (startDate) => <p>{dateUtil.formatFullDateTime(startDate)}</p>,
  },
  {
    title: "Ends",
    dataIndex: "endDate",
    key: "endDate",
    render: (endDate) => <p>{dateUtil.formatFullDateTime(endDate)}</p>,
  },
];

export const transactionsColumn = [
  {
    title: "Name",
    dataIndex: "user",
    key: "user",
    render: (user) => {
      return (
        <p>
          {user?.first_name} {user?.last_name}
        </p>
      );
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (amount) => {
      return <p>{helpers.toCurrency(amount)}</p>;
    },
  },
  {
    title: "Fees",
    dataIndex: "fees",
    key: "fees",
    render: (fees) => {
      return <p>{helpers.toCurrency(fees)}</p>;
    },
  },
  {
    title: "Reference",
    dataIndex: "reference",
    key: "reference",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Processed By",
    dataIndex: "processedBy",
    key: "processedBy",
  },
  {
    title: "Action Type",
    dataIndex: "action",
    key: "action",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Transaction Date",
    dataIndex: "transaction_date",
    key: "reference",
    render: (transaction_date) => {
      return <p>{dateUtil.formatFullDateTime(transaction_date)}</p>;
    },
  },
  {
    title: "Actions",
    key: "action",
  },
];
